import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteSupplierId, setUpdateSupplierId} from "../../actions/supplier";
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { usePermission } from '../../hooks/usePermission';

const SupplierItem = ({
                          setDeleteSupplierId,
                          setUpdateSupplierId,
                          number,
                          supplier: {
                              id, name, contractor,
                              inn, phone,
                              bank_account, client,
                          },
                          showActions,
                      }) => {
    const { userCan } = usePermission();

    if (!userCan('view suppliers')) {
        return null;
    }

    const setDeleteSupplier = (id) => {
        setDeleteSupplierId(id);
    };

    const setUpdateSupplier = (id) => {
        setUpdateSupplierId(id);
    };

    return (
        <Fragment>
            <tr>
                <th scope="row">{number}</th>
                <td>{name}</td>
                <td>{contractor}</td>
                <td>{inn}</td>
                <td>
                    {userCan('view clients') && client?.id ? (
                        <Link to={`clients/${client.id}`}>{client.name}</Link>
                    ) : (
                        client?.name || ''
                    )}
                </td>
                <td>{phone}</td>
                <td>{bank_account}</td>
                <td>
                    <div className="d-flex gap-2">
                        {userCan('view suppliers') && (
                            <Link to={`suppliers/${id}`}>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </Button>
                            </Link>
                        )}
                        {userCan('edit suppliers') && (
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setUpdateSupplier(id)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </Button>
                        )}
                        {userCan('delete suppliers') && (
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setDeleteSupplier(id)}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        )}
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

SupplierItem.defaultProps = {
    showActions: true,
};

SupplierItem.propTypes = {
    supplier: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        contractor: PropTypes.string,
        inn: PropTypes.string,
        phone: PropTypes.string,
        bank_account: PropTypes.string,
        client: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    }).isRequired,
    number: PropTypes.number.isRequired,
    showActions: PropTypes.bool,
    setDeleteSupplierId: PropTypes.func.isRequired,
    setUpdateSupplierId: PropTypes.func.isRequired
};

export default connect(null, {setDeleteSupplierId, setUpdateSupplierId})(SupplierItem);
